export default function initBurgerMenu() {
  const holder = document.body;
  const navOpener = holder?.querySelector('.nav-opener');
  const activeClass = 'nav-active';

  navOpener.addEventListener('click', (e) => {
    e.preventDefault();
    holder.classList.toggle(activeClass);
  });
}
